import React from 'react';
import Header from "../components/Header/Header";
import NewBanner from "../Home/components/Banner/NewBanner";
import {Button, Flex, Table} from "antd";
import {clrs} from "../../constants/colors";
import {Fade} from "react-awesome-reveal";
import MyText from "../../components/UI/Text/MyText";
import IntlMessage from "../../components/IntlMessage/IntlMessage";
import Footer from "../components/Footer/Footer";
import {EyeOutlined} from "@ant-design/icons";
import {useNavigate} from "react-router-dom";
import {micro_qualifications} from "./qualifications";
import {LocalName} from "../../utils/LocalName";

const MicroQualificationsListPage = () => {
    const navigate = useNavigate();
    const columns = [
        {
            title: <MyText center strong><IntlMessage id={"educationField"}/></MyText>,
            render: (_, record) => (
                <MyText center>{LocalName.getName(record.educationField)}</MyText>
            ),
            width: '18%',
        },
        {
            title: <MyText center strong><IntlMessage id={"trainingDirection"}/></MyText>,
            render: (_, record) => (
                <MyText center>{LocalName.getName(record.trainingDirection)}</MyText>
            ),
            width: '18%',
        },
        {
            title: <MyText center strong><IntlMessage id={"groupEP"}/></MyText>,
            render: (_, record) => (
                <MyText center>{LocalName.getName(record.groupEP)}</MyText>
            ),
            width: '18%',
        },
        {
            title: <MyText center strong><IntlMessage id={"microQEP"}/></MyText>,
            render: (_, record) => (
                <MyText center>{LocalName.getName(record.microQEP)}</MyText>
            ),
            width: '15%',
        },
        {
            title: <MyText center strong><IntlMessage id={"partnerOrg"}/></MyText>,
            render: (_, record) => (
                <MyText center>{LocalName.getName(record.partnerOrg)}</MyText>
            ),
            width: '25%',
        },
        {
            title: "",
            render: (_, record) => (
                <Button onClick={() => {
                    navigate(`/micro-qualification/${record.microQEP.nameEng}`, {state: record})
                }}>
                    <EyeOutlined/>
                </Button>
            ),
            width: '5%',
        },
    ];

    return (
        <div>
            <Header/>
            <Flex style={{width: "100%", position: "relative", padding: "120px 20px 20px 20px"}} align={"center"}
                  justify={"center"}>
                <Flex gap={50} style={{width: "100%", maxWidth: 1440, position: "relative"}} vertical
                      align={"flex-start"} justify={"flex-start"}>
                    <NewBanner/>
                    <Flex gap={80} style={{width: "100%", maxWidth: 1440, position: "relative"}} vertical
                          align={"center"} justify={"flex-start"}>

                        <Fade triggerOnce={true} cascade damping={0.15} direction={"down"}>
                            <MyText center stronger uppercase size={"larger"}>
                                <IntlMessage id={"microQReg"}/>
                            </MyText>
                        </Fade>
                        <Fade triggerOnce={true} cascade damping={0.20} direction={"up"} style={{width: "100%", overflowX: "auto"}}>
                            <Table style={{minWidth: 800}} columns={columns} dataSource={micro_qualifications}
                                   pagination={false}
                                   bordered/>
                            {/*<GridTable columns={columns} data={data}/>*/}
                        </Fade>
                    </Flex>
                </Flex>
            </Flex>
            <Footer/>
        </div>
    );
};

const GridTable = ({columns, data}) => {
    const gridTemplate = columns
        .map((col) => col.width || "auto")
        .join(" ");

    return (
        <div
            style={{
                width: "100%",
                border: "0.5px solid #D7D7D7",
                borderRadius: "20px",
                overflow: "hidden"
            }}
        >
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: gridTemplate,
                    backgroundColor: clrs.yellow,
                    color: "black",
                    borderBottom: "1px solid #D7D7D7"
                }}
            >
                {columns.map((col, i) => (
                    <div
                        key={i}
                        style={{
                            padding: "8px",
                            textAlign: "center",
                            fontWeight: "bold"
                        }}
                    >
                        {col.title}
                    </div>
                ))}
            </div>

            {data.map((record, rowIndex) => (
                <div
                    key={rowIndex}
                    style={{
                        display: "grid",
                        gridTemplateColumns: gridTemplate,
                        borderBottom:
                            rowIndex !== data.length - 1
                                ? "1px solid #D7D7D7"
                                : "none"
                    }}
                >
                    {columns.map((col, colIndex) => (
                        <div
                            key={colIndex}
                            style={{
                                padding: "8px",
                                textAlign: "center"
                            }}
                        >
                            {col.render
                                ? col.render(null, record)
                                : record[col.dataIndex]}
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
};
export default MicroQualificationsListPage;